import {
	ImageCarouselBannerInputSchema,
	ImageCarouselBannerOutputSchema
} from "src/features/HomepageCarouselBanners/models/imageCarouselBanner.model";

import {
	TextCarouselBannerInputSchema,
	TextCarouselBannerOutputSchema
} from "src/features/HomepageCarouselBanners/models/textCarouselBanner.model";

import {
	VideoCarouselBannerInputSchema,
	VideoCarouselBannerOutputSchema
} from "src/features/HomepageCarouselBanners/models/videoCarouselBanner.model";

import { z } from "zod";

// Banner Template
export const BannerTemplateSchema = z.enum([
	"fullImageBanner",
	"textBanner",
	"videoBanner"
]);
export type BannerTemplate = z.infer<typeof BannerTemplateSchema>;

// Create CarouselBanner Form Valdiation Schema
export const CreateCarouselBannerSchema = z.discriminatedUnion("template", [
	ImageCarouselBannerInputSchema,
	VideoCarouselBannerInputSchema,
	TextCarouselBannerInputSchema
]);

export const CarouselBannerSchema = z.discriminatedUnion("template", [
	ImageCarouselBannerOutputSchema,
	VideoCarouselBannerOutputSchema,
	TextCarouselBannerOutputSchema
]);

export const CarouselBannersOuputSchema = z.array(CarouselBannerSchema);

export type CreateCarouselBannerInput = z.infer<
	typeof CreateCarouselBannerSchema
>;

export type CarouselBannerModel = z.infer<typeof CarouselBannerSchema>;
